import React from "react";
import { useState } from "react";
import { useEffect } from "react";

const Loading = ({ img, width, height, fadeIt }) => {
  const [readyToFade, setReadyToFade] = useState(false);
  useEffect(() => {
    if (fadeIt?.status) setTimeout(fadeTheLoading, fadeIt?.seconds);
  });
  const fadeTheLoading = () => {
    setReadyToFade(true);
  };
  return (
    <div className={`loads-loading ${readyToFade ? "fadeOut" : "fadeIn"}`}>
      {!readyToFade && (
        <img
          src={process.env.PUBLIC_URL + `/assets/images/loads/${img}.gif`}
          width={width}
          height={height}
        />
      )}
    </div>
  );
};

export default Loading;
